import { render, staticRenderFns } from "./Bookkeeping.vue?vue&type=template&id=8f706938&scoped=true&"
import script from "./Bookkeeping.vue?vue&type=script&lang=js&"
export * from "./Bookkeeping.vue?vue&type=script&lang=js&"
import style0 from "./Bookkeeping.vue?vue&type=style&index=0&id=8f706938&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f706938",
  null
  
)

export default component.exports